import { useEffect } from 'react'
import { useDispatch } from 'react-redux'

import { actionNames } from '../shared/actions.playback'
import { switchToTray, useFloorState } from '../../firebase/hooks/useFloor'
import {
  usePlaybackState,
  setPlaybackState,
} from '../../firebase/hooks/useVideoPlayback'
import { useHeadlessParticipant } from '../../webrtc/webRTCRoom'
import { useLastActiveMediaTrayCard } from '../../firebase/hooks/useTray'
import { usePanel } from '../../firebase/hooks/usePanel'
import { ChyronType } from '../../firebase/model/chyron-model'
import {
  removeOverlay,
  useOverlayState,
} from '../../firebase/hooks/useOverlays'

// TODO: this is all business logic that could and should live outside of react
const usePlaybackStateUpdated = () => {
  const playbackState = usePlaybackState()

  const floor = useFloorState()
  const panel = usePanel()
  const lastActiveMediaTrayCard = useLastActiveMediaTrayCard()
  const overlay = useOverlayState()

  const dispatch = useDispatch()

  const { state, statePayload } = playbackState ?? {}
  const headless = useHeadlessParticipant()

  /*
   * Effect that triggers when headless is ready to play a video
   */
  useEffect(() => {
    if (!headless || state !== 'headless_play_ready') {
      return
    }

    if (
      !(
        floor?.layout === 'panel' &&
        panel?.mode === 'manual' &&
        panel?.screen === 'tray' &&
        lastActiveMediaTrayCard?.type === 'video'
      )
    ) {
      if (overlay?.type === ChyronType.Speaker) {
        removeOverlay()
      }
      switchToTray()
    }

    setPlaybackState('producer_play_ready')
  }, [
    panel,
    floor,
    state,
    headless,
    lastActiveMediaTrayCard?.type,
    overlay?.type,
  ])

  /*
   * Effect that triggers when video is being played
   */
  useEffect(() => {
    if (state !== 'playing') {
      return
    }

    dispatch({
      type: actionNames.VIDEO_PLAYBACK_STARTED,
      selectedPlaybackPhotoId: statePayload.photoId,
    })
  }, [state, statePayload, dispatch])

  /*
   * Effect that triggers when video is being paused
   */
  useEffect(() => {
    if (state !== 'paused') {
      return
    }

    // include all the data again in case producer joins during playing
    dispatch({
      type: actionNames.VIDEO_PLAYBACK_STARTED,
      selectedPlaybackPhotoId: statePayload.photoId,
    })

    dispatch({ type: actionNames.UPDATE_PAUSED_STATE })
  }, [state, dispatch, statePayload])

  /*
   * Effect that triggers when video is being ended
   */
  useEffect(() => {
    if (state !== 'ended') {
      return
    }

    // include all the data again in case producer joins during playing
    dispatch({
      type: actionNames.VIDEO_ENDED,
      selectedPlaybackPhotoId: statePayload.photoId,
    })
  }, [state, dispatch, statePayload])
}

export default usePlaybackStateUpdated
